import type { IUser } from '@carboncopyco/types';
import { capitalize } from '@carboncopyco/utils';
import type { Colors } from '../../constants';
import type { AvatarSize } from '../Avatar';
import { Spacer } from '../Spacer';
import { TooltipBubble } from '../TooltipBubble';
import { TextBase } from '../Typography';
import { UserAvatar } from '../UserAvatar';

export interface UserBasicInfoProps {
  user: Pick<IUser, 'firstName' | 'lastName' | 'name'> &
    Partial<Pick<IUser, 'isDeleted' | 'image'>>;
  textColor?: Colors;
  size?: AvatarSize;
  truncateWidth?: number;
  tooltip?: boolean;
  disable?: boolean;
}

export const UserBasicInfo = ({
  user,
  textColor = 'text-ds-natural',
  size,
  truncateWidth,
  tooltip,
  disable,
}: UserBasicInfoProps) => {
  const firstName = capitalize(user?.firstName);
  const lastName = capitalize(user?.lastName);

  const isDisabled = disable || user?.isDeleted;
  const fullName = firstName
    ? `${firstName} ${lastName}`
    : user?.name ?? 'Anonymous';

  return (
    <div className="flex items-center">
      <UserAvatar
        user={user}
        size={size}
      />
      <Spacer amount={0.5} />
      <div
        className={`truncate leading-4 ${textColor}`}
        style={{
          maxWidth: truncateWidth && `${truncateWidth}px`,
        }}
      >
        <TooltipBubble
          placement="top-start"
          title={user?.name ?? fullName}
          disabled={!tooltip}
        >
          <div
            className={`truncate leading-4 ${textColor}`}
            style={{
              maxWidth: truncateWidth && `${truncateWidth}px`,
            }}
          >
            <TextBase
              label={user?.name ?? fullName}
              color={isDisabled ? 'text-ds-natural-200' : textColor}
            />
          </div>
        </TooltipBubble>
      </div>
    </div>
  );
};
